module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-20 ovf-hd"
  }, [_c('div', {
    staticClass: "fl w-400"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名/企业名/报销消费事由/备注/票据类型",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1)], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.page_height,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "企业"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "报销人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reason",
      "label": "报销事由",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "consume_money",
      "label": "报销金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报销状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.status == -1) ? _c('span', [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (scope.row.status == 0) ? _c('span', [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', [_vm._v("待审批")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', [_vm._v("待核销")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('span', [_vm._v("已驳回")]) : _vm._e(), _vm._v(" "), (scope.row.status == 5) ? _c('span', [_vm._v("待支付")]) : _vm._e(), _vm._v(" "), (scope.row.status == 6) ? _c('span', [_vm._v("已完成")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "label": "票据类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "consume_time",
      "label": "消费时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "consume_reason",
      "label": "消费事由",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "申请时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remarks",
      "label": "备注",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill_url",
      "label": "发票"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.bill_url) ? _c('el-popover', {
          attrs: {
            "placement": "right-end",
            "width": "400",
            "trigger": "click"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.bill_url,
            "width": "100%"
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "slot": "reference",
            "src": scope.row.bill_url,
            "width": "50",
            "height": "50"
          },
          slot: "reference"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'billEdit',
                params: {
                  id: scope.row.id
                }
              })
            }
          }
        }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('span')])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "详情",
      "visible": _vm.dialogVisible,
      "direction": _vm.direction
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n      企业："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.company_name))])])]), _vm._v(" "), _c('div', [_vm._v("\n      部门："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.branch))])])]), _vm._v(" "), _c('div', [_vm._v("\n      报销人："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.user_name))])])]), _vm._v(" "), _c('div', [_vm._v("\n      报销事由："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.reason))])])]), _vm._v(" "), _c('div', [_vm._v("\n      报销金额："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.consume_money))])])]), _vm._v(" "), _c('div', [_vm._v("\n      报销状态："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.status))])])]), _vm._v(" "), _c('div', [_vm._v("\n      票据类型："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.cost))])])]), _vm._v(" "), _c('div', [_vm._v("\n      消费时间："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.consume_time))])])]), _vm._v(" "), _c('div', [_vm._v("\n      消费事由："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.consume_reason))])])]), _vm._v(" "), _c('div', [_vm._v("\n      申请时间："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.create_time))])])]), _vm._v(" "), _c('div', [_vm._v("\n      备注："), _c('span', [_c('b', [_vm._v(_vm._s(_vm.detail.remarks))])])]), _vm._v(" "), _c('div', [_vm._v("\n      发票："), _c('span', [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.detail.bill_url
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'bill'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-607dae3d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/bill/list.vue
// module id = 1846
// module chunks = 2